import {
  CLEAR_ALL_DIRECTORY_DATA,
  CLEAR_DIRECTORY_DATA,
  GET_ADMIN_ROOT_DIRECTORIES_SUCCESS,
  GET_DIRECTORIES_BY_ID_SUCCESS,
  GET_DIRECTORIES_SUCCESS,
  GET_DIRECTORY_DATA_BY_ID_SUCCESS,
  GET_DIRECTORY_DATA_FOR_EDIT_SUCCESS,
  GET_NUMBER_OF_CHILDREN_SUCCESS,
  SEARCH_DIRECTORY_SUCCESS,
} from '../actionConstants';

const defaultState = {
  shouldClearBreadcrumbs: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_DIRECTORIES_SUCCESS:
    case SEARCH_DIRECTORY_SUCCESS:
    case GET_DIRECTORIES_BY_ID_SUCCESS: {
      return {
        ...state,
        shouldClearBreadcrumbs: false,
        directories: action.res.data,
      };
    }
    case GET_DIRECTORY_DATA_BY_ID_SUCCESS: {
      return {
        ...state,
        shouldClearBreadcrumbs: false,
        directoryData: action.payload.data,
      };
    }
    case GET_DIRECTORY_DATA_FOR_EDIT_SUCCESS: {
      return {
        ...state,
        shouldClearBreadcrumbs: false,
        directoryDataForEdit: action.payload.data,
      };
    }
    case GET_ADMIN_ROOT_DIRECTORIES_SUCCESS: {
      return {
        ...state,
        shouldClearBreadcrumbs: false,
        adminRootDirectories: action.payload.data,
      };
    }
    case GET_NUMBER_OF_CHILDREN_SUCCESS: {
      return {
        ...state,
        numberOfChildren: action.payload.data,
      };
    }
    case '@@router/LOCATION_CHANGE':
    case CLEAR_DIRECTORY_DATA: {
      return {
        ...state,
        directoryData: {},
        directoryDataForEdit: {},
        numberOfChildren: {},
        shouldClearBreadcrumbs: true,
      };
    }
    case CLEAR_ALL_DIRECTORY_DATA:
      return defaultState;
    default:
      return state;
  }
};
